// @flow

import { Text } from '@gandi/ui';

import { CatalogPrice } from 'src/DomainCreate/components/ProvidedArea/PriceArea/CatalogPrice';
import { useAppSelector } from 'src/hooks';

import { selectTaxesIncluded } from '../../Layout/modules/selectors';
import type { ResultItem } from '../types';

import { useChangeText } from './modules';

type Props = {
  domain: ResultItem,
};

export function TransferDomainPrice({
  domain,
}: Props): React.MixedElement | null {
  const taxesIncluded = useAppSelector(selectTaxesIncluded);

  const duration = domain.price?.duration || 1;
  const changeText = useChangeText({
    change: domain.price?.change || '',
    duration,
  });

  if (!domain.price) return null;

  const price =
    (taxesIncluded
      ? domain.price.amount.afterTaxes
      : domain.price.amount.beforeTaxes) * duration;

  return (
    <CatalogPrice
      currency={domain.price.currency}
      price={price}
      minDuration={duration}
      priceDiff={0}
      showFromPrice={false}
    >
      <Text color="light" size="small">
        {changeText}
      </Text>
    </CatalogPrice>
  );
}
